//takes in an array of objects describing inputs, returns the rendered component
import React, { useState, useEffect } from 'react';
import '../../../../styles/query/breathe.scss'



const Audio = (props) => {

  return (
    <>
    <div className="watch-face">
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
    </div>

    </>
  )
}


export default Audio;